import React from "react";

interface NumberBadgeProps {
    value: number | string;
    className?: string;
}

export const NumberBadge: React.FC<NumberBadgeProps> = ({
    value,
    className = "",
}) => {
    return (
        <div className="flex items-center justify-center h-full">
            <span
                className={`inline-flex items-center justify-center w-8 h-8 bg-slate-100 rounded-full text-sm font-semibold text-slate-700 ${className}`}
            >
                {value}
            </span>
        </div>
    );
};
